import axios from 'axios';
import type { PcAttentionItem, PcBoard, PcTriageResult, PcWorkQueue } from './types';

const HOME = '/api/private-credit/home';

export const getPcBoard = async (needsAttention = false, mine = false): Promise<PcBoard> =>
  (await axios.get<PcBoard>(`${HOME}/board`, { params: { needsAttention, mine, _: Date.now() } })).data;

export const getPcWorkQueue = async (params: { workflow?: string; severity?: string; loanId?: number; mine?: boolean; includeTriaged?: boolean } = {}): Promise<PcWorkQueue> =>
  (await axios.get<PcWorkQueue>(`${HOME}/queue`, { params: { ...params, _: Date.now() } })).data;

export const assignPcOwner = async (key: string, owner: string): Promise<unknown> =>
  (await axios.post(`${HOME}/queue/owner`, { key, owner })).data;

export const triagePcItems = async (keys: string[], action: 'ACKNOWLEDGE' | 'SNOOZE' | 'DISMISS' | 'REOPEN', reason?: string, snoozeUntil?: string): Promise<PcTriageResult> =>
  (await axios.post<PcTriageResult>(`${HOME}/queue/triage`, { keys, action, reason, snoozeUntil })).data;

export const getPcAttention = async (loanId: number): Promise<PcAttentionItem[]> =>
  (await axios.get<PcAttentionItem[]>(`${HOME}/loans/${loanId}/attention`, { params: { _: Date.now() } })).data;

/** The server's message for a refused request, else a fallback. */
export const pcErrorMessage = (failure: unknown, fallback: string): string => {
  if (axios.isAxiosError(failure)) {
    const body = failure.response?.data as { error?: string; message?: string } | undefined;
    return body?.error || body?.message || failure.message || fallback;
  }
  return failure instanceof Error ? failure.message : fallback;
};

export const getPcServicing = async (loanId: number): Promise<import('./types').PcServicing> =>
  (await axios.get(`${HOME}/loans/${loanId}/servicing`, { params: { _: Date.now() } })).data;

export const getPcAgreement = async (loanId: number): Promise<import('./types').PcAgreement> =>
  (await axios.get(`${HOME}/loans/${loanId}/agreement`, { params: { _: Date.now() } })).data;
export const getPcDocuments = async (loanId: number): Promise<import('./types').PcDocuments> =>
  (await axios.get(`${HOME}/loans/${loanId}/documents`, { params: { _: Date.now() } })).data;
export const getPcActivity = async (loanId: number, params: { workflow?: string; actor?: string; limit?: number; offset?: number } = {}): Promise<import('./types').PcActivity> =>
  (await axios.get(`${HOME}/loans/${loanId}/activity`, { params: { ...params, _: Date.now() } })).data;
